import { CombinedState, combineReducers } from 'redux'
import authenticateReducer, { AuthenticationState } from './authenticateReducer'
import deleteReducer, {
	SmartCheckSessionState,
} from './smartCheckSessionDeletionReducer'
import flowEntryStatemachineReducer, {
	FlowEntryStatemachineState,
} from './flowEntryStatemachineReducer'

export interface RootState {
	authentication: AuthenticationState
	deletion: SmartCheckSessionState
	flowEntryStatemachine: FlowEntryStatemachineState
}

export default (): CombinedState<any> => {
	const rootReducer = combineReducers({
		authentication: authenticateReducer,
		deletion: deleteReducer,
		flowEntryStatemachine: flowEntryStatemachineReducer,
	})
	return rootReducer
}
